import { render } from "./feeder_pillar_page.vue?vue&type=template&id=c5fb556e&scoped=true"
import script from "./feeder_pillar_page.vue?vue&type=script&lang=js"
export * from "./feeder_pillar_page.vue?vue&type=script&lang=js"

import "./feeder_pillar_page.vue?vue&type=style&index=0&id=c5fb556e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5fb556e"]])

export default __exports__